// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/svg-border-dashed.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/map-data-container/map-data-container.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/map-data-container/map-data-container-alt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/alert-tile-bg/Red.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/alert-tile-bg/Yellow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/alert-tile-bg/Orange.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/alert-tile-bg/Green.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/map-small-grid.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/maps-tags-pins-frames/map-label-frame-md.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --text-dark: #0F141B;
  --text-light: #FFFFFF;

  --link-active: #54E7FBCC;

  --background-light: #F2F9FF;

  /*ESCALATION RATING -> SEVERITY COLORS */
  --high-rating-color: #D50032;
  --high_medium-rating-color: #F56811;
  --medium-rating-color: #FFCD00;
  --low-rating-color: #009639;
  font-size: 1vw;
}

:root,
* {
  font-family: 'ADNOC Sans', Arial;
  letter-spacing: .25px;
}

::-webkit-input-placeholder {
  font-style: italic;
  font-weight: 500;
}

:-moz-placeholder {
  font-style: italic;
  font-weight: 500;
}

::-moz-placeholder {
  font-style: italic;
  font-weight: 500;
}

:-ms-input-placeholder {
  font-style: italic;
  font-weight: 500;
}

body {
  font-family: 'ADNOC Sans', Arial;
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100vw;
  background: var(--background-light);
  background-size: 33%;
  background-attachment: fixed;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  box-sizing: 'border-box';
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

#root {
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

::placeholder {
  color: var(--text-dark) !important;
  opacity: 0.8 !important;
}

.chart svg .MuiChartsAxis-line,
.chart svg .MuiChartsAxis-tick {
  stroke: var(--text-dark);
}

.chart svg .MuiChartsAxis-tickLabel,
.chart svg .MuiChartsAxis-label,
.chart svg .MuiChartsLegend-series text {
  fill: white;
}

.chart svg .MuiChartsLegend-series text {
  fill: white !important;
}

.chart svg .MuiChartsAxisHighlight-root {
  stroke: white !important;
}


button.active-link {
  border: 2px solid #FFFFFF;
}

.background-filter::before {
  content: ' ';
  position: absolute;
  height: calc(100% + 24px);
  box-shadow: none;
  width: 125%;
  background: linear-gradient(94.85deg, #bf58d130 2.31%, #6FE8D530 51.15%, #1E91E030 100%);
  filter: blur(16px);
  transform: rotate(-180deg);
}

.custom_popup {
  width: 12.5vw;
  color: black;
  background: white !important;
  border: solid;
  box-shadow: none;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  box-sizing: border-box;
  z-index: 10000;
  border: 0.125vw solid red;
}

.custom_popup .leaflet-popup-content-wrapper {
  background: transparent;
  padding: 0;
  margin: 0;
  border-radius: 0;
  /* height: auto; */
  box-sizing: border-box;
}

.custom_popup .leaflet-popup-tip-container {
  display: none;
}

/* .custom_popup .leaflet-popup-content {
  width: 100%;
  padding: 0;
  margin: 0;
  background-color: transparent;
  content: ' ';
  box-shadow: none !important;
  box-sizing: border-box;
}  */

/* .custom_popup.high svg{
  background: url('./assets//icons//map-marker-high.svg');
}

.custom_popup.medium svg{
  background: url('./assets//icons//map-marker-medium.svg');
}

.custom_popup.low svg{
  background: url('./assets//icons//map-marker-low.svg');
} */
.custom_popup .leaflet-popup-tip-container {
  display: none;
}

.leaflet-control-attribution {
  display: none;
}

.leaflet-popup-content-wrapper {
  box-shadow: none;
}

.custom_popup.left {
  top: -50px;
  left: -225px !important;
}

.custom_popup.right {
  top: -50px;
  left: 25px !important;
}

.custom_popup.bottom {
  top: 25px;
  right: 0px !important;
}

svg.gradient-bordered-icon path {
  stroke: linear-gradient(94.85deg, #5A4EB4 2.31%, #00A9B1 51.15%, #2E79B3 100%);
}

a {
  font-weight: 700;
  line-height: 44px;
  color: var(--text-light);
  text-decoration: none;
  transition: color 200ms ease-in-out;
}

a.active {
  color: var(--link-active)
}

a:hover {
  color: var(--link-active)
}

.masthead_link {
  color: #00A9B1;
  ;
  text-decoration: underline;
}

.masthead_link:hover {
  text-decoration: none;
}

.masthead_link::before {
  color: var(--text-dark);
  content: '<';
  display: inline-block;
  width: 1ch;
  margin-right: .5rem;
}

.landing_kpi_summary {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-position: center;
  background-size: 100%;
  background-position: top;
}

.landing-metric {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  background-position: center;
  background-size: contain;
}

.landing-metric:first-of-type {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
  background-position: center;
  background-size: contain;
}

.text_primary_gradient {
  background: linear-gradient(97.54deg, #05B8E0 5.84%, #0077BC 158.69%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

/*
::-webkit-scrollbar {
  width: 7px;
}

::-webkit-scrollbar-track {
  z-index: -1;
  background: transparent;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: #3ED4DC;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #2d979d;
}
*/

.alert {
  background-size: contain;
  background-repeat: no-repeat;
}

.high:not(.custom_popup) {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: contain;
  background-repeat: no-repeat;
}

.medium:not(.custom_popup) {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: contain;
  background-repeat: no-repeat;
}

.high.medium,
.highmedium,
.high-medium {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: contain;
  background-repeat: no-repeat;
}

.low:not(.custom_popup) {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: contain;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 0 0;
}

.map_wrapper {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat;
  background-size: 125%;
  background-position: 50px 0px;
}

.custom_popup .leaflet-popup-content-wrapper {
  box-shadow: none;
}

.custom_popup .leaflet-popup-content {
  width: inherit !important;
  padding: 10px;
  box-sizing: 'border-box';
  line-height: 1;
  display: grid;
  grid-template-columns: 0.2fr 1fr;
  row-gap: 0.75vh;
  margin: 0;
  background: var(--text-light);
  border: 0.125vw solid green;
}

.custom_popup .leaflet-popup-content>p {
  padding: 0;
  margin: 0 !important;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1;
}

.leaflet-tooltip {
  align-items: center;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  color: white;
  background-size: contain;
  border: none;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: none;
  padding: 10px 22px;
  display: flex;
  justify-content: space-between;
}

.leaflet-tooltip .label_strong {
  font-weight: 700;
  text-transform: uppercase;
}

.leaflet-tooltip-top::before,
.leaflet-tooltip-bottom::before,
.leaflet-tooltip-left::before,
.leaflet-tooltip-right::before {
  display: none;
}

.very_advanced_marker .outer_circle_high::after,
.very_advanced_marker .outer_circle_high-medium::after {
  opacity: 0;
  position: absolute;
  content: '';
  height: 100%;
  width: 100%;
  border-radius: 100%;
  animation-name: ripple;
  animation-duration: 800ms;
  animation-delay: 0;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(.65, 0, .34, 1);
  z-index: -1;
}

.very_advanced_marker .outer_circle_high::after {
  background-color: var(--high-rating-color);
}

.very_advanced_marker .outer_circle_high-medium::after {
  background-color: var(--high_medium-rating-color);
  animation-duration: 1100ms;
}

@keyframes ripple {
  from {
    opacity: 1;
    transform: scale3d(0.75, 0.75, 1);
  }

  to {
    opacity: 0;
    transform: scale3d(2, 2, 1);
  }
}

body .gmnoprint {
  display: none
}

svg.cursor {
  display: inline-block;
  width: 1ch;
  animation: flicker 0.2s infinite;
}

svg.cursor>rect {
  fill: 'black'
}

.cursor_block {
  display: inline-block;
  width: 1ch;
  position: relative;
  top: 0.125ch;
  aspect-ratio: 1/1.5;
  animation: flicker 0.4s infinite;
  background: var(--text-dark);
}

@keyframes flicker {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

/* 
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  :root {
      font-size: 2rem;
  }
} */

/* 1280x720 */
@media (max-width: 1280px) {
  :root {
    font-size: 1vw;
  }
}

/* 1920x1080 */
@media (min-width: 1281px) and (max-width: 1920px) {
  :root {
    font-size: 0.8vw;
  }
}

/* 2560x1440 */
@media (min-width: 1921px) and (max-width: 2560px) {
  :root {
    font-size: 0.85vw;
  }
}

/* 3840x2160 */
@media (min-width: 2561px) {
  :root {
    font-size: 0.9vw;
  }
}

svg.marker-details>* {
  line-height: 1;
  font-size: 12px !important
}

svg.marker-details.left {
  grid-column-start: -1;
  transform: rotateY(180deg) translate(calc(100%), 0)
}

svg.marker-details.left p {
  transform: rotateY(180deg);
  direction: rtl;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,qBAAqB;;EAErB,wBAAwB;;EAExB,2BAA2B;;EAE3B,wCAAwC;EACxC,4BAA4B;EAC5B,mCAAmC;EACnC,8BAA8B;EAC9B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;EAEE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;EACZ,mCAAmC;EACnC,oBAAoB;EACpB,4BAA4B;EAC5B,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,wFAAwF;EACxF,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;;IAQI;;AAEJ;;;;;;;;;;GAUG;AACH;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;;EAEd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,6DAA2D;EAC3D,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,6DAA+E;EAC/E,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,6DAAmF;EACnF,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,qEAAqE;EACrE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;;;;;;;;;;;;;;;;;;CAkBC;;AAED;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,mDAAiD;EACjD,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,mDAAoD;EACpD,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;;;EAGE,mDAAoD;EACpD,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,mDAAmD;EACnD,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,6DAAwD;EACxD,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,SAAS;EACT,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mDAAwE;EACxE,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;EACnC,uDAAuD;EACvD,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;;;;;GAKG;;AAEH,aAAa;AACb;EACE;IACE,cAAc;EAChB;AACF;;AAEA,cAAc;AACd;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,cAAc;AACd;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,cAAc;AACd;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB","sourcesContent":[":root {\n  --text-dark: #0F141B;\n  --text-light: #FFFFFF;\n\n  --link-active: #54E7FBCC;\n\n  --background-light: #F2F9FF;\n\n  /*ESCALATION RATING -> SEVERITY COLORS */\n  --high-rating-color: #D50032;\n  --high_medium-rating-color: #F56811;\n  --medium-rating-color: #FFCD00;\n  --low-rating-color: #009639;\n  font-size: 1vw;\n}\n\n:root,\n* {\n  font-family: 'ADNOC Sans', Arial;\n  letter-spacing: .25px;\n}\n\n::-webkit-input-placeholder {\n  font-style: italic;\n  font-weight: 500;\n}\n\n:-moz-placeholder {\n  font-style: italic;\n  font-weight: 500;\n}\n\n::-moz-placeholder {\n  font-style: italic;\n  font-weight: 500;\n}\n\n:-ms-input-placeholder {\n  font-style: italic;\n  font-weight: 500;\n}\n\nbody {\n  font-family: 'ADNOC Sans', Arial;\n  margin: 0;\n  padding: 0;\n  height: 100vh;\n  width: 100vw;\n  background: var(--background-light);\n  background-size: 33%;\n  background-attachment: fixed;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n  box-sizing: 'border-box';\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n#root {\n  width: 100vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n::placeholder {\n  color: var(--text-dark) !important;\n  opacity: 0.8 !important;\n}\n\n.chart svg .MuiChartsAxis-line,\n.chart svg .MuiChartsAxis-tick {\n  stroke: var(--text-dark);\n}\n\n.chart svg .MuiChartsAxis-tickLabel,\n.chart svg .MuiChartsAxis-label,\n.chart svg .MuiChartsLegend-series text {\n  fill: white;\n}\n\n.chart svg .MuiChartsLegend-series text {\n  fill: white !important;\n}\n\n.chart svg .MuiChartsAxisHighlight-root {\n  stroke: white !important;\n}\n\n\nbutton.active-link {\n  border: 2px solid #FFFFFF;\n}\n\n.background-filter::before {\n  content: ' ';\n  position: absolute;\n  height: calc(100% + 24px);\n  box-shadow: none;\n  width: 125%;\n  background: linear-gradient(94.85deg, #bf58d130 2.31%, #6FE8D530 51.15%, #1E91E030 100%);\n  filter: blur(16px);\n  transform: rotate(-180deg);\n}\n\n.custom_popup {\n  width: 12.5vw;\n  color: black;\n  background: white !important;\n  border: solid;\n  box-shadow: none;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  box-sizing: border-box;\n  z-index: 10000;\n  border: 0.125vw solid red;\n}\n\n.custom_popup .leaflet-popup-content-wrapper {\n  background: transparent;\n  padding: 0;\n  margin: 0;\n  border-radius: 0;\n  /* height: auto; */\n  box-sizing: border-box;\n}\n\n.custom_popup .leaflet-popup-tip-container {\n  display: none;\n}\n\n/* .custom_popup .leaflet-popup-content {\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  background-color: transparent;\n  content: ' ';\n  box-shadow: none !important;\n  box-sizing: border-box;\n}  */\n\n/* .custom_popup.high svg{\n  background: url('./assets//icons//map-marker-high.svg');\n}\n\n.custom_popup.medium svg{\n  background: url('./assets//icons//map-marker-medium.svg');\n}\n\n.custom_popup.low svg{\n  background: url('./assets//icons//map-marker-low.svg');\n} */\n.custom_popup .leaflet-popup-tip-container {\n  display: none;\n}\n\n.leaflet-control-attribution {\n  display: none;\n}\n\n.leaflet-popup-content-wrapper {\n  box-shadow: none;\n}\n\n.custom_popup.left {\n  top: -50px;\n  left: -225px !important;\n}\n\n.custom_popup.right {\n  top: -50px;\n  left: 25px !important;\n}\n\n.custom_popup.bottom {\n  top: 25px;\n  right: 0px !important;\n}\n\nsvg.gradient-bordered-icon path {\n  stroke: linear-gradient(94.85deg, #5A4EB4 2.31%, #00A9B1 51.15%, #2E79B3 100%);\n}\n\na {\n  font-weight: 700;\n  line-height: 44px;\n  color: var(--text-light);\n  text-decoration: none;\n  transition: color 200ms ease-in-out;\n}\n\na.active {\n  color: var(--link-active)\n}\n\na:hover {\n  color: var(--link-active)\n}\n\n.masthead_link {\n  color: #00A9B1;\n  ;\n  text-decoration: underline;\n}\n\n.masthead_link:hover {\n  text-decoration: none;\n}\n\n.masthead_link::before {\n  color: var(--text-dark);\n  content: '<';\n  display: inline-block;\n  width: 1ch;\n  margin-right: .5rem;\n}\n\n.landing_kpi_summary {\n  background: url('./assets/svg-border-dashed.svg') no-repeat;\n  background-position: center;\n  background-size: 100%;\n  background-position: top;\n}\n\n.landing-metric {\n  background: url('./assets/map-data-container/map-data-container.svg') no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n\n.landing-metric:first-of-type {\n  background: url('./assets/map-data-container/map-data-container-alt.svg') no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n\n.text_primary_gradient {\n  background: linear-gradient(97.54deg, #05B8E0 5.84%, #0077BC 158.69%);\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n/*\n::-webkit-scrollbar {\n  width: 7px;\n}\n\n::-webkit-scrollbar-track {\n  z-index: -1;\n  background: transparent;\n  border-radius: 10px;\n}\n::-webkit-scrollbar-thumb {\n  background: #3ED4DC;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #2d979d;\n}\n*/\n\n.alert {\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.high:not(.custom_popup) {\n  background: url('./assets/alert-tile-bg/Red.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.medium:not(.custom_popup) {\n  background: url('./assets/alert-tile-bg/Yellow.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.high.medium,\n.highmedium,\n.high-medium {\n  background: url('./assets/alert-tile-bg/Orange.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.low:not(.custom_popup) {\n  background: url('./assets/alert-tile-bg/Green.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: 0 0;\n}\n\n.map_wrapper {\n  background: url('./assets/map-small-grid.svg') no-repeat;\n  background-size: 125%;\n  background-position: 50px 0px;\n}\n\n.custom_popup .leaflet-popup-content-wrapper {\n  box-shadow: none;\n}\n\n.custom_popup .leaflet-popup-content {\n  width: inherit !important;\n  padding: 10px;\n  box-sizing: 'border-box';\n  line-height: 1;\n  display: grid;\n  grid-template-columns: 0.2fr 1fr;\n  row-gap: 0.75vh;\n  margin: 0;\n  background: var(--text-light);\n  border: 0.125vw solid green;\n}\n\n.custom_popup .leaflet-popup-content>p {\n  padding: 0;\n  margin: 0 !important;\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 1;\n}\n\n.leaflet-tooltip {\n  align-items: center;\n  background: url('./assets/maps-tags-pins-frames/map-label-frame-md.svg');\n  color: white;\n  background-size: contain;\n  border: none;\n  background-position: center;\n  background-repeat: no-repeat;\n  box-shadow: none;\n  padding: 10px 22px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.leaflet-tooltip .label_strong {\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.leaflet-tooltip-top::before,\n.leaflet-tooltip-bottom::before,\n.leaflet-tooltip-left::before,\n.leaflet-tooltip-right::before {\n  display: none;\n}\n\n.very_advanced_marker .outer_circle_high::after,\n.very_advanced_marker .outer_circle_high-medium::after {\n  opacity: 0;\n  position: absolute;\n  content: '';\n  height: 100%;\n  width: 100%;\n  border-radius: 100%;\n  animation-name: ripple;\n  animation-duration: 800ms;\n  animation-delay: 0;\n  animation-iteration-count: infinite;\n  animation-timing-function: cubic-bezier(.65, 0, .34, 1);\n  z-index: -1;\n}\n\n.very_advanced_marker .outer_circle_high::after {\n  background-color: var(--high-rating-color);\n}\n\n.very_advanced_marker .outer_circle_high-medium::after {\n  background-color: var(--high_medium-rating-color);\n  animation-duration: 1100ms;\n}\n\n@keyframes ripple {\n  from {\n    opacity: 1;\n    transform: scale3d(0.75, 0.75, 1);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale3d(2, 2, 1);\n  }\n}\n\nbody .gmnoprint {\n  display: none\n}\n\nsvg.cursor {\n  display: inline-block;\n  width: 1ch;\n  animation: flicker 0.2s infinite;\n}\n\nsvg.cursor>rect {\n  fill: 'black'\n}\n\n.cursor_block {\n  display: inline-block;\n  width: 1ch;\n  position: relative;\n  top: 0.125ch;\n  aspect-ratio: 1/1.5;\n  animation: flicker 0.4s infinite;\n  background: var(--text-dark);\n}\n\n@keyframes flicker {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n/* \n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n  :root {\n      font-size: 2rem;\n  }\n} */\n\n/* 1280x720 */\n@media (max-width: 1280px) {\n  :root {\n    font-size: 1vw;\n  }\n}\n\n/* 1920x1080 */\n@media (min-width: 1281px) and (max-width: 1920px) {\n  :root {\n    font-size: 0.8vw;\n  }\n}\n\n/* 2560x1440 */\n@media (min-width: 1921px) and (max-width: 2560px) {\n  :root {\n    font-size: 0.85vw;\n  }\n}\n\n/* 3840x2160 */\n@media (min-width: 2561px) {\n  :root {\n    font-size: 0.9vw;\n  }\n}\n\nsvg.marker-details>* {\n  line-height: 1;\n  font-size: 12px !important\n}\n\nsvg.marker-details.left {\n  grid-column-start: -1;\n  transform: rotateY(180deg) translate(calc(100%), 0)\n}\n\nsvg.marker-details.left p {\n  transform: rotateY(180deg);\n  direction: rtl;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
